import styled from 'styled-components';

export const MainContentContainer = styled.main`
  padding-top: ${props => props.paddingTop};
`;

MainContentContainer.displayName = 'MainContentContainer';
